<!--
 * @Author: wufei
 * @Date: 2020-08-13 10:16:56
 * @LastEditTime: 2020-10-12 16:45:01
 * @Description:
 * @FilePath: \mobile-revive\src\views\index\month.vue
-->
<template>
  <div class="revive-month" @click="popdown">
    <div v-if="show" class="mask" />
    <header>
      <ul>
        <li :class="{active:show === 'year'}" @click.stop="showPopup('year')">{{ showYear }} <icon name="arrow-down" /></li>
        <li :class="{active:show === 'month'}" @click.stop="showPopup('month')">{{ showMonth }} <icon name="arrow-down" /></li>
        <li :class="{active:show === 'department'}" @click.stop="showPopup('department')">
          <div class="busList">
            {{ showBus }}
          </div>
          <icon name="arrow-down" />
        </li>
        <li :class="{active:show === 'city'}" @click.stop="showPopup('city')">
          <div class="busList">
            {{ showCity }}
          </div>
          <icon name="arrow-down" />
        </li>
      </ul>
      <div v-if="show" class="popup">
        <picker
          v-show="show == 'year'"
          title="请选择年份"
          :columns="years"
          :default-index="yearIndex"
          @change="yearChange"
        />

        <div v-show="show == 'month'" class="months">
          <div v-for="item in months" :key="item.text" class="item" :class="{active:item.state,disable:!item.enabled}" @click.stop="monthSelected(item)">{{ item.text }}月</div>
        </div>

        <picker
          v-show="show == 'department'"
          title="请选择事业部"
          value-key="orgShortName"
          :columns="BussinesDepList"
          :default-index="busIndex"
          @change="busChange"
        />

        <picker
          v-show="show == 'city'"
          title="请选择城市公司"
          value-key="orgShortName"
          :columns="cityCompanyList"
          :default-index="cityIndex"
          @change="cityChange"
        />
      </div>
    </header>

    <revive-table
      v-if="tableRender"
      :curr-year="currYear"
      :select-month="selectMonth"
      :curr-bus="currBus"
      :curr-city="currCity"
      :time="time"
    />
  </div>
</template>

<script>
import { setTitle } from '@/api/dd'
import reviveTable from './table'
import { Icon, Picker, Toast, Button } from 'vant'
import { getBussinesDeptList, getCitycompanyList, getDataDict } from '@/api/sys'
import { scatterChart, lineChart, findOpeningTimeMonth } from '@/api/revive'
export default {
    name: 'ReviceMonth',
    components: {
        Icon,
        Picker,
        reviveTable
    },
    data() {
        return {
            userBelong: JSON.parse(sessionStorage.getItem('userBelone')),
            time: +new Date(),
            currentDate: new Date().getFullYear(),
            currYear: new Date().getFullYear(),
            selectMonth: [],
            show: '',
            years: [],
            months: [],
            selectedMonth: [],
            yearIndex: 0,
            currBus: '',
            currCity: '',
            busIndex: 0,
            cityIndex: 0,
            BussinesDepList: [],
            cityCompanyList: [],
            tableRender: false
        }
    },
    computed: {
        showYear() {
            if (this.currYear) {
                return this.currYear
            }
            return '不限'
        },
        showMonth() {
            let text = ''
            if (this.selectedMonth.length) {
                this.selectedMonth.forEach(item => {
                    text += item.text + '月 '
                })
                text.trim()
                return text
            }
            return '不限'
        },
        showBus() {
            const bus = this.BussinesDepList.find(item => item.orgDeptId === this.currBus)
            if (bus) {
                return bus.orgShortName
            }
            return '事业部'
        },
        showCity() {
            const bus = this.cityCompanyList.find(item => item.orgDeptId === this.currCity)
            if (bus) {
                return bus.orgShortName
            }
            return '全部'
        }
    },
    watch: {
        selectedMonth(n) {
            this.months.forEach(item => {
                const select = n.find(month => month.text === item.text)
                item.state = false
                if (select) {
                    item.state = true
                }
            })
        },
        async yearIndex(n) {
            const item = this.years[n]
            this.currYear = item.text
            console.log('n', n)
            if (n == '0') {
                this.months.forEach(item => {
                    item.enabled = false
                    item.state = false
                })
                this.selectMonth = []
                this.selectedMonth = []
            } else {
                await this.findOpeningTimeMonth()
            }
            this.time = +new Date()
        },
        busIndex(n) {
            const item = this.BussinesDepList[n]
            this.currBus = item.orgDeptId
            if (this.currBus) {
                this.getCitycompanyList()
            } else {
                this.cityCompanyList = []
                const all = {
                    orgDeptId: '',
                    orgShortName: '全部'
                }
                this.cityCompanyList.unshift(all)
            }
            this.time = +new Date()
        },
        cityIndex(n) {
            const item = this.cityCompanyList[n]
            this.currCity = item.orgDeptId
            this.time = +new Date()
        }
    },
    async created() {
        setTitle('上月开盘')
        this.initYear()
        await this.findOpeningTimeMonth()
        await this.getBussinesDeptList()
        if (this.userBelong.type === 3) {
            await this.getCitycompanyList()
        }
        await this.lineChart()
    },
    methods: {
        async findOpeningTimeMonth() {
            const parmas = {
                openingTimeYear: this.currYear,
                deptId: this.currBus,
                cityCompId: this.currCity
            }
            await findOpeningTimeMonth(parmas).then(res => {
                this.months.forEach(item => {
                    const month = res.find(month => +month == item.text)
                    if (month) {
                        item.enabled = true
                    } else {
                        item.enabled = false
                        item.state = false
                    }
                })
                this.selectedMonth = this.months.filter(item => item.state)
                const selectMonth = this.selectedMonth.map(item => {
                    if (item.text < 10) {
                        return '0' + item.text
                    }
                    return item.text
                })
                this.selectMonth = selectMonth
            })
        },
        async lineChart() {
            const selectMonth = this.selectedMonth.map(item => {
                if (item.text < 10) {
                    return '0' + item.text
                }
                return item.text
            })
            this.selectMonth = selectMonth
            const parmas = {
                openingTimeYear: this.currYear === '0' ? '' : this.currYear,
                openingTimeMonths: selectMonth
            }
            await lineChart(parmas).then(res => {
                const userBelong = JSON.parse(sessionStorage.getItem('userBelone'))
                if (userBelong.type === 1) {
                    this.currBus = res.length && res[0].orgId || ''
                    const index = this.BussinesDepList.findIndex(item => item.orgDeptId === this.currBus)
                    this.busIndex = index
                }
                this.tableRender = true
            })
        },
        busChange(picker, value, index) {
            this.busIndex = index
        },
        cityChange(picker, value, index) {
            this.cityIndex = index
        },
        yearChange(picker, value, index) {
            this.yearIndex = index
        },
        async getBussinesDeptList() {
            let type = 292700
            let ids = []
            await getDataDict({type}).then(res => {
                ids = JSON.parse(res[0].otherCode)
            })
            console.log(ids)
            // const ids = ['10010000', '10100000', '10040000', '10030000', '50007348', '10270000',
            //     '10120000', '10150000', '10070000', '10020000', '50007031', '10060000', '10170000', '10080000', '10130000', '10110000']
            await getBussinesDeptList().then(res => {
                this.BussinesDepList = res
                this.BussinesDepList = this.BussinesDepList.filter(item => {
                    if (ids.includes(item.orgDeptId)) {
                        return item
                    }
                })
                this.BussinesDepList.forEach(item => {
                    item.orgShortName = item.orgShortName
                        .replace('区域集团', '')
                        .replace('城市更新', '城更')
                        .replace('城市公司', '')
                        .replace('事业部', '')
                        .replace('区域集团', '')
                        .replace('旭辉银盛泰集团', '')
                        .replace('办事处', '')
                        .replace('公司', '')
                        .replace('区域', '')
                })

                const all = {
                    orgDeptId: '',
                    orgShortName: '全国'
                }
                this.BussinesDepList.unshift(all)
                const userBelong = JSON.parse(sessionStorage.getItem('userBelone'))
                if (userBelong.type != 1) {
                    this.BussinesDepList = this.BussinesDepList.filter(item => item.orgDeptId === userBelong.areaDeptId)
                    this.currBus = userBelong.areaDeptId
                }
            })
        },
        async getCitycompanyList() {
            await getCitycompanyList(this.currBus).then(res => {
                this.cityCompanyList = res
                const all = {
                    orgDeptId: '',
                    orgShortName: '全部'
                }
                this.cityCompanyList.unshift(all)

                if (this.userBelong.type === 3) {
                    this.cityCompanyList = this.cityCompanyList.filter(item => item.orgDeptId === this.userBelong.cityCompId)
                    this.currCity = this.userBelong.cityCompId
                }
            })
        },
        popdown() {
            if (this.show) {
                this.time = +new Date()
            }
            this.show = false
        },
        getActive(month) {
            const item = this.selectedMonth.find(item => item == month)
            if (item) {
                return true
            }
            return false
        },
        monthSelected(month) {
            if (!month.enabled) {
                Toast.fail('该月份不可选')
                return false
            }
            this.selectedMonth = [month]
            const text = month.text < 10 ? '0' + month.text : month.text
            this.selectMonth = [text]
            this.popdown()
        },
        monthCheck(month) {
            let {text, state} = month
            this.selectedMonth = this.months.filter(item => item.state)
            let min = 13
            let max = 0
            this.selectedMonth.forEach(item => {
                if (min > item.text) {
                    min = item.text
                }
                if (max < item.text) {
                    max = item.text
                }
            })
            // console.log('max', max, 'min', min)
            if (!state) {
                if (text < min) return
                if (text < max) {
                    this.selectedMonth = this.selectedMonth.filter(item => {
                        return item.text < text
                    })
                }
            }

        },
        initYear() {
            this.years = ['不限']
            // const minYear = this.currentDate - 100
            for (let i = 2019;i <= this.currentDate;i++) {
                this.years.push({text: i})
            }
            this.yearIndex = this.years.length - 1

            // let month = new Date().getMonth() + 1
            let month = new Date().getMonth()
            month = month === 0 ? 12 : month
            // 如果是12月份年份回到上一年
            this.yearIndex = month === 12 ? this.yearIndex - 1 : this.yearIndex
            // 默认选中上个月
            for (let i = 1;i <= 12;i++) {
                this.months.push({text: i, state: month === i})
                if (month === i) {
                    this.selectedMonth.push({text: i, state: month === i})
                }

            }
        },
        showPopup(type) {
            this.show = type
        }
    }
}
</script>

<style lang="scss" scoped>
  .revive-month {
      box-sizing: border-box;
      overflow-y: auto;
      height:100%;
      font-size:.28rem /* 28/100 */;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      padding-bottom: 1.5rem;

      .mask {
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.42);
        position: absolute;
        z-index: 98;
      }

      header {
        z-index:99;
        width:100%;
        height:.9rem /* 90/100 */;
        background: white;
        position: relative;
        ul {
          display:flex;
          padding:0 .3rem;
          li {
            display:flex;
            justify-content: center;
            flex:1;
            line-height:.9rem /* 90/100 */;
            .busList {
                max-width:1rem /* 100/100 */;
                white-space: nowrap;
                text-overflow:ellipsis;
                overflow:hidden;
            }
            i {
                line-height:.9rem /* 90/100 */;
            }
          }
          li.active {
            color:#2761FF;
          }
        }
        .popup {
          position: absolute;
          z-index:99;
          width:100%;
          .months {
            display: flex;
            flex-wrap: wrap;
            background: white;
            padding:.25rem /* 10/100 */;
            .item {
              width:1.55rem /* 155/100 */;
              height:.46rem /* 46/100 */;
              background:rgba(247,247,247,1);
              border-radius:.04rem /* 4/100 */;
              margin:.1rem /* 20/100 */;
              font-size:.24rem /* 24/100 */;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(110,110,110,1);
              line-height:.46rem /* 46/100 */;
              text-align: center;
            }
            .active {
              background:#2761FF;
              color:white;
            }
            .disable {
              background:rgba(0,0,0,.6);
              color:white;
            }
          }
        }
      }
  }
</style>
